import React from 'react';
import { BuscaNfeContextProvider } from './BuscaNfeContext';
import { BuscaNfeContent } from './BuscaNfeContent';
import { BuscaNfeProps } from './protocols';

export const BuscaNfe: any = ({
  codLoja,
  fornecedorOption,
  numNF,
  quantityItems = 0,
  setNfData,
  reset,
  disabled = false,
  loja = undefined,
}: BuscaNfeProps) => {
  return (
    <BuscaNfeContextProvider
      codLoja={codLoja}
      fornecedorOption={fornecedorOption}
      numNF={numNF}
      quantityItems={quantityItems}
      setNfData={setNfData}
      reset={reset}
      disabled={disabled}
      lojaUser={loja}
    >
      <BuscaNfeContent />
    </BuscaNfeContextProvider>
  );
};
